<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('school.academic.setup.program.grade.grade') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('school.academic.setup.program.grade.grade'),
          href: '/grades'
        },
        {
          text: $t('school.academic.setup.program.grade.edit'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12">
                  <fieldset>
                    <legend class="text-black">
                      {{ $t('school.academic.setup.program.grade.gradInfo') }}
                    </legend>
                    <div class="ts-space-y-1">
                      <div class="row">
                        <div class="col-md-6">
                          <label>
                            {{
                              $t(
                                'school.academic.setup.program.grade.main_program'
                              )
                            }}
                            <i class="fas fa-question-circle" v-if="!ready_fetch" v-tooltip="$t(
                              'school.academic.setup.program.grade.select_main_program_to_filter_sub_program'
                            )
                              "></i>
                            <i class="fas fa-spinner spin" v-else></i>
                          </label>
                          <a-select v-model="model.acp_id" style="width: 100%" showSearch :placeholder="$t(
                            'school.academic.setup.program.grade.main_program'
                          )
                            " :filterOption="(input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                              " @change="onMainProgramChange(model.acp_id)">
                            <a-select-option v-for="(main, index) in main_programs" :key="index" :value="main.acp_id">
                              {{ main.acp_name_foreign }}
                            </a-select-option>
                          </a-select>
                        </div>
                        <div class="col-md-6">
                          <label>
                            {{
                              $t(
                                'school.academic.setup.program.grade.sub_program'
                              )
                            }}
                            <i v-if="!fetch_sub" class="fas fa-question-circle" v-tooltip="$t(
                              'school.academic.setup.program.grade.select_sub_program_to_filter_level'
                            )
                              "></i>
                            <i class="fas fa-spinner spin" v-else></i>
                          </label>
                          <a-select v-model="model.acps_id" style="width: 100%" showSearch :placeholder="$t(
                            'school.academic.setup.program.grade.sub_program'
                          )
                            " :filterOption="(input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                              " @change="onSubProgramChange(model.acps_id)">
                            <a-select-option v-for="(sub, index) in sub_programs" :key="index" :value="sub.acps_id">
                              {{ sub.acps_name_foreign }}
                            </a-select-option>
                          </a-select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label class="col-form-label required">
                            {{
                              $t('school.academic.setup.program.grade.level')
                            }}
                            <i class="fas fa-spinner spin" v-if="fetch_level"></i>
                          </label>
                          <a-select v-model="model.level_id" style="width: 100%" showSearch :placeholder="$t(
                            'school.academic.setup.program.grade.sub_program'
                          )
                            " :filterOption="(input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                              " @change="getGradeBaseOnMainProgram">
                            <a-select-option v-for="(level, index) in levels" :key="index" :value="level.level_id">
                              {{ level.level_name_foreign }}
                            </a-select-option>
                          </a-select>
                          <div class="validate" v-if="errors.has('level_id')">
                            {{ errors.first('level_id') }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <label class="col-form-label">
                            {{
                              $t(
                                'school.academic.setup.program.grade.next_grade'
                              )
                            }}
                            <i class="fas fa-spinner spin" v-if="fetch_next_grade"></i>
                          </label>
                          <a-select v-model.number="model.next_grade_id" style="width: 100%" showSearch :filterOption="(input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                            ">
                            <a-select-option v-for="(grade, index) in next_grades" :key="index" :value="grade.grade_id">
                              {{ grade.grade_name_foreign }}
                            </a-select-option>
                          </a-select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label class="col-form-label">
                            {{
                              $t('school.academic.setup.program.grade.name_kh')
                            }}
                          </label>
                          <input type="text" v-model.trim="model.grade_name_native" class="form-control" :class="{
                            'is-invalid': errors.has('grade_name_native')
                          }" />
                          <div class="invalid-feedback" v-if="errors.has('grade_name_native')">
                            {{ errors.first('grade_name_native') }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <label class="col-form-label required">{{
                            $t('school.academic.setup.program.grade.name_en')
                          }}</label>
                          <input type="text" v-model.trim="model.grade_name_foreign" class="form-control" :class="{
                            'is-invalid': errors.has('grade_name_foreign')
                          }" />
                          <div class="invalid-feedback" v-if="errors.has('grade_name_foreign')">
                            {{ errors.first('grade_name_foreign') }}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label class="col-form-label required">
                            {{
                              $t(
                                'school.academic.setup.program.grade.abbreviation'
                              )
                            }}
                          </label>
                          <input type="text" v-model.trim="model.grade_abbr" class="form-control"
                            :class="{ 'is-invalid': errors.has('grade_abbr') }" />
                          <div class="invalid-feedback" v-if="errors.has('grade_abbr')">
                            {{ errors.first('grade_abbr') }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row">
                            <div class="col-md-6">
                              <label class="col-form-label required">
                                {{
                                  $t(
                                    'school.academic.setup.program.grade.grade_order'
                                  )
                                }}
                              </label>
                              <input type="number" v-model.number="model.grade_order" class="form-control" :class="{
                                'is-invalid': errors.has('grade_order')
                              }" />
                              <div class="invalid-feedback" v-if="errors.has('grade_order')">
                                {{ errors.first('grade_order') }}
                              </div>
                            </div>
                            <div class="col-md-6">
                              <label class="col-form-label">
                                {{
                                  $t(
                                    'school.academic.setup.program.grade.displayOrder'
                                  )
                                }}
                              </label>
                              <input type="number" v-model.number="model.display_order" class="form-control" :class="{
                                'is-invalid': errors.has('display_order')
                              }" />
                              <div class="invalid-feedback" v-if="errors.has('display_order')">
                                {{ errors.first('display_order') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="col-md-12 ts-mt-3">
                  <fieldset>
                    <legend>
                      {{ $t('school.academic.setup.program.grade.scoring') }}
                    </legend>
                    <div class="ts-space-y-1">
                      <div class="row">
                        <div class="col-md-6">
                          <label class="col-form-label required">
                            {{
                              $t(
                                'school.academic.setup.program.grade.scoring_type'
                              )
                            }}
                          </label>
                          <a-select v-model.number="model.score_type" style="width: 100%" showSearch :filterOption="(input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                            " @change="model.sc_bas_id = null">
                            <a-select-option :value="1">Numbering</a-select-option>
                            <a-select-option :value="2">Grading</a-select-option>
                            <a-select-option :value="3">Rating</a-select-option>
                          </a-select>
                          <div class="validate" v-if="errors.has('score_type')">
                            {{ errors.first('score_type') }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <label class="col-form-label">
                            {{
                              $t(
                                'school.academic.setup.program.grade.ignoreCycle'
                              )
                            }}
                            <i class="fas fa-question-circle" v-tooltip="'Choose which type of scoring cycle for specific core subject that you want to ignore on it.'
                              "></i>
                          </label>
                          <a-select v-model="model.ignore_scoring_on_cycle" mode="multiple" :maxTagTextLength="10"
                            :maxTagCount="1" :options="ignoreCycles" class="ts-w-full ts-text-xs"></a-select>
                          <div class="invalid-feedback" v-if="errors.has('ignore_scoring_on_cycle')">
                            {{ errors.first('ignore_scoring_on_cycle') }}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label class="col-form-label required">
                            {{
                              $t(
                                'school.academic.setup.program.grade.monthlyScore'
                              )
                            }}
                          </label>
                          <a-select v-model.number="model.monthly_score_sc_bas_id" style="width: 100%" showSearch
                            :filterOption="(input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                              ">
                            <a-select-option :value="1">Item Base</a-select-option>
                            <a-select-option :value="2">Subject Base</a-select-option>
                          </a-select>
                          <div class="validate" v-if="errors.has('monthly_score_sc_bas_id')">
                            {{ errors.first('monthly_score_sc_bas_id') }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <label class="col-form-label required">
                            {{
                              $t(
                                'school.academic.setup.program.grade.semesterScore'
                              )
                            }}
                          </label>
                          <a-select v-model.number="model.semester_score_sc_bas_id" style="width: 100%" showSearch
                            :filterOption="(input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                              ">
                            <a-select-option :value="1">Item Base</a-select-option>
                            <a-select-option :value="2">Subject Base</a-select-option>
                          </a-select>
                          <div class="validate" v-if="errors.has('semester_score_sc_bas_id')">
                            {{ errors.first('semester_score_sc_bas_id') }}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label class="col-form-label">
                            {{
                              $t(
                                'school.academic.setup.program.grade.ignoreRatingCycle'
                              )
                            }}
                            <i class="fas fa-question-circle" v-tooltip="'Choose which type of scoring cycle that you want to perform rating on.'
                              "></i>
                          </label>
                          <a-select v-model="model.enable_rating_on_cycle" mode="multiple" :maxTagTextLength="10"
                            :maxTagCount="1" :options="ignoreCycles" class="ts-w-full ts-text-xs"></a-select>
                        </div>
                        <div class="col-md-6 ts-pt-8">
                          <ts-checkbox v-model="model.attendance_by_subject">
                            {{
                              $t(
                                'school.academic.setup.program.grade.attendance_by_subject'
                              )
                            }}
                          </ts-checkbox>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <panel :title="$t('school.academic.setup.program.grade.subjects')">
                <div>
                  <label class="ts-border-b ts-border-gray-500 ts-w-full ts-pb-1 ts-uppercase">
                    {{ $t('school.academic.setup.program.grade.subjects') }}
                  </label>
                  <div id="subject-list">
                    <p class="text-center" v-if="subjects.length == 0 && !fetch_subject">
                      <small>
                        <i>
                          {{
                            $t(
                              'school.academic.setup.program.grade.display_subject_lists'
                            )
                          }}
                        </i>
                      </small>
                    </p>
                    <p class="text-center" v-if="fetch_subject">
                      <i class="fas fa-spinner spin"></i> Loading...
                    </p>
                    <div>
                      <a-checkbox-group v-model="model.subject_list" @change="onChangeSubject">
                        <a-row>
                          <a-col :span="12" v-for="(subject, index) in subjects" :key="index"
                            :value="subject.subject_id">
                            <a-checkbox :value="subject.subject_id">{{
                              subject.subject_name_foreign +
                              (subject.subject_code
                                ? ' | ' + subject.subject_code + `(${subject.subject_id})`
                                : `(${subject.subject_id})`)
                            }}</a-checkbox>
                          </a-col>
                        </a-row>
                      </a-checkbox-group>
                    </div>
                  </div>
                </div>
                <!-- Elective Subject -->
                <div>
                  <label class="ts-border-b ts-border-gray-500 ts-w-full ts-pb-1 ts-uppercase">
                    {{
                      $t('school.academic.setup.program.grade.electiveSubject')
                    }}
                  </label>
                  <div id="lea-exp-subject-list">
                    <p class="text-center" v-if="subjects.length == 0 && !fetch_subject">
                      <small>
                        <i>
                          {{
                            $t(
                              'school.academic.setup.program.grade.display_subject_lists'
                            )
                          }}
                        </i>
                      </small>
                    </p>
                    <p class="text-center" v-if="fetch_subject">
                      <i class="fas fa-spinner spin"></i> Loading...
                    </p>
                    <a-tree v-model:checkedKeys="checkedKeys" checkable :defaultExpandAll="true"
                      :tree-data="subject_learning_expectations" @check="onChangeLeaExpSubject">
                    </a-tree>
                  </div>
                </div>

                <div>
                  <GroupSubject v-model="model" :validate="errors" :subjects="subjects" />
                </div>
              </panel>
            </div>
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 text-right">
              <ts-button class="btn-primary mr-2" :waiting="waiting" @click.prevent="update">{{ $t('update')
              }}</ts-button>
              <ts-button @click="$router.push({ name: 'grade' })">{{
                $t('cancel')
              }}</ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import FormComponent from './core-program.vue'
import GroupSubject from './group-subject.vue'
import { split } from 'lodash'

export default {
  name: 'grade-edit',
  components: {
    GroupSubject
  },
  data() {
    return {
      model: {
        grade_id: '',
        acp_id: '',
        acps_id: '',
        level_id: '',
        grade_name_native: '',
        grade_name_foreign: '',
        grade_abbr: '',
        grade_order: '',
        display_order: 0,
        next_grade_id: '',
        attendance_by_subject: false,
        subject_list: [],
        score_type: 1,
        monthly_score_sc_bas_id: '',
        semester_score_sc_bas_id: '',
        core_pro_list: [],
        ignore_scoring_on_cycle: [],
        enable_rating_on_cycle: [],
        lea_exp_subject_list: [],
        grade_subject_group: []
      },
      number_of_term_per_grade: null,
      subject_learning_expectations: [],
      sub_programs: [],
      levels: [],
      subjects: [],
      next_grades: [],
      ready_fetch: false,
      fetch_sub: false,
      fetch_level: false,
      fetch_subject: false,
      fetch_next_grade: false,
      waiting: false,
      errors: new Errors(),
      expandedKeys: [],
      selectedKeys: [],
      checkedKeys: [],
      old_subject_list: []
    }
  },
  async created() {
    await this.fetchResourceBeforeCreate()
    await this.setEditData()
  },
  computed: {
    ...mapState('grade', ['main_programs', 'edit_data', 'core_programs']),
    ignoreCycles() {
      return this.$store.state.grade.ignore_cycle.map(el => ({
        value: el.scoring_cycle_id,
        label: el.scoring_cycle_name
      }))
    }
  },
  methods: {
    onChangeLeaExpSubject(subject_list) {
      let elective_subject_only = subject_list.filter(p => !p.includes('H'))

      this.model.lea_exp_subject_list = this.model.lea_exp_subject_list.map(
        el => ({
          grade_id: el.grade_id,
          id: el.id,
          is_deleted: elective_subject_only
            .map(es => split(es, '-')[0] + split(es, '-')[2])
            .includes(el.term_order + el.lea_exp_subject_id)
            ? 0
            : 1,
          lea_exp_subject_id: el.lea_exp_subject_id,
          subject_id: el.subject_id,
          subject_name_foreign: el.subject_name_foreign,
          term_order: el.term_order
        })
      )
    },
    onChangeSubject(subject_list) {
      if (subject_list.length > this.old_subject_list.length) {
        let new_subject = subject_list.filter(
          p => !this.old_subject_list.includes(p)
        )
        let subject = this.subjects.find(e => e.subject_id == new_subject)
        this.old_subject_list = subject_list
        if (!subject.is_elective_subject_parent) {
          return 0
        }
      }
      if (subject_list.length < this.old_subject_list.length) {
        let new_subject = this.old_subject_list.filter(
          p => !subject_list.includes(p)
        )
        let subject = this.subjects.find(e => e.subject_id == new_subject)
        this.old_subject_list = subject_list
        if (!subject.is_elective_subject_parent) {
          return 0
        }
      }
      //record old subject
      this.old_subject_list = subject_list

      this.checkedKeys = []
      this.subject_learning_expectations = []
      for (let index = 1; index <= this.number_of_term_per_grade; index++) {
        let lea_exp_subject_list = []
        //check all select subject
        subject_list.map(el => {
          let subject = this.subjects.find(e => e.subject_id == el)
          //check if is_elective_subject_parent is true
          if (
            subject.is_elective_subject_parent &&
            subject.children.length > 0
          ) {
            //create lea_exp_subject_list by term
            this.expandedKeys.push(subject.subject_id)
            lea_exp_subject_list.push({
              title:
                'Subject: ' +
                subject.subject_name_foreign +
                ' ' +
                subject.subject_code,
              key: 'H' + index + '-' + subject.subject_id,
              children: subject.children.map(el => ({
                title:
                  'Subject: ' + el.subject_name_foreign + ' ' + el.subject_code,
                key: index + '-' + subject.subject_id + '-' + el.subject_id
              }))
            })
            //Push to checkedKeys
            let subject_key = 'H' + index + '-' + subject.subject_id
            this.checkedKeys.push(subject_key)
            subject.children.map(el => {
              let lea_exp_subject_key =
                index + '-' + subject.subject_id + '-' + el.subject_id
              this.checkedKeys.push(lea_exp_subject_key)
            })
          }
        })
        if (lea_exp_subject_list.length > 0) {
          //push it to list for display
          this.expandedKeys.push('Term: ' + index)
          this.subject_learning_expectations.push({
            title: 'Term: ' + index,
            key: 'H' + index,
            children: lea_exp_subject_list
          })
          //Push to checkedKeys
          let term_key = 'H' + index
          this.checkedKeys.push(term_key)
        }
      }

      //Create New
      this.model.lea_exp_subject_list = []
      let elective_subject_only = this.checkedKeys.filter(p => !p.includes('H'))

      elective_subject_only.map(eso => {
        let s = split(eso, '-')
        let in_edit_data = this.edit_data.subjects.find(
          e => e.term_order == s[0] && e.lea_exp_subject_id == s[2]
        )

        if (in_edit_data) {
          this.model.lea_exp_subject_list.push({
            grade_id: in_edit_data.grade_id,
            id: in_edit_data.id,
            is_deleted: in_edit_data.is_deleted,
            lea_exp_subject_id: in_edit_data.lea_exp_subject_id,
            subject_id: in_edit_data.subject_id,
            subject_name_foreign: in_edit_data.subject_name_foreign,
            term_order: in_edit_data.term_order
          })
        } else {
          this.model.lea_exp_subject_list.push({
            grade_id: null,
            id: 0,
            is_deleted: 1,
            lea_exp_subject_id: s[2],
            subject_id: s[1],
            subject_name_foreign: null,
            term_order: s[0]
          })
          // when select subject not auto select
          this.checkedKeys = []
        }
      })
    },
    createForm() {
      this.$modal.show(
        FormComponent,
        {
          value: this.model
        },
        {
          height: 'auto',
          width: '35%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          // 'before-close': this.fetchResourceBeforeCreate,
        }
      )
    },
    remove(core) {
      var index = this.model.core_pro_list.indexOf(
        this.model.core_pro_list.find(e => e.core_pro_id == core.core_pro_id)
      )
      this.model.core_pro_list.splice(index, 1)
    },
    fetchResourceBeforeCreate() {
      this.ready_fetch = true
      this.$store
        .dispatch('grade/dataBeforeCreate')
        .then(response => {
          this.ready_fetch = false
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    onMainProgramChange(acp_id) {
      this.model.acps_id = ''
      this.model.level_id = ''
      this.subjects = this.levels = this.next_grades = this.model.subject_list = []
      this.fetch_sub = true
      this.$store
        .dispatch('grade/getSubProgram', acp_id ? acp_id : 0)
        .then(response => {
          this.fetch_sub = false
          this.sub_programs = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetch_sub = false
        })
    },
    async onSubProgramChange(acps_id, acp_id) {
      this.model.level_id = ''
      this.subjects = this.levels = this.next_grades = this.model.subject_list = []
      this.fetch_level = true
      this.fetch_subject = true
      let level = await this.$store.dispatch(
        'grade/getLevel',
        acps_id ? acps_id : 0
      )
      this.levels = level.data
      this.fetch_level = false
      let subject = await this.$store.dispatch('grade/getSubject', {
        acps_id: acps_id ? acps_id : 0,
        acp_id: acp_id
      })
      this.subjects = subject.data
      this.fetch_subject = false

      this.number_of_term_per_grade = this.sub_programs.find(
        e => e.acps_id == acps_id
      ).number_of_term_per_grade
    },

    async getGradeBaseOnMainProgram(acp_id) {
      if (!acp_id) {
        return
      }
      this.model.next_grade_id = ''
      this.fetch_next_grade = true
      this.$store
        .dispatch('grade/getGrade', acp_id)
        .then(response => {
          this.next_grades = response.data
          this.fetch_next_grade = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetch_next_grade = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('grade/update', this.model)
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'grade' })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    async setEditData() {
      await this.onMainProgramChange(
        this.edit_data.level.sub_program.main_program.acp_id
      )
      await this.onSubProgramChange(
        this.edit_data.level.sub_program.acps_id,
        this.edit_data.level.sub_program.main_program.acp_id
      )
      await this.getGradeBaseOnMainProgram(
        this.edit_data.level.sub_program.acp_id
      )

      this.model = {
        grade_id: this.edit_data.grade_id,
        acp_id: this.edit_data.level.sub_program.main_program.acp_id,
        acps_id: this.edit_data.level.sub_program.acps_id,
        level_id: this.edit_data.level_id,
        grade_name_native: this.edit_data.grade_name_native,
        grade_name_foreign: this.edit_data.grade_name_foreign,
        grade_abbr: this.edit_data.grade_abbr,
        grade_order: this.edit_data.grade_order,
        display_order: this.edit_data.display_order,
        next_grade_id: this.edit_data.next_grade_id,
        attendance_by_subject: this.edit_data.attendance_by_subject,
        subject_list: [],
        score_type: this.edit_data.score_type,
        monthly_score_sc_bas_id: this.edit_data.monthly_score_sc_bas_id,
        semester_score_sc_bas_id: this.edit_data.semester_score_sc_bas_id,
        core_pro_list: this.edit_data.academic_core_program,
        ignore_scoring_on_cycle: [],
        enable_rating_on_cycle: [],
        lea_exp_subject_list: [],
        grade_subject_group: this.edit_data.grade_subject_group.map(el => ({
          grade_subject_group_id: el.grade_subject_group_id,
          grade_id: el.grade_id,
          item_group: el.item_group,
          subject_id_list: el.subject_id_list.split(",").map(Number)
        }))
      }
      let enable_rating_on_cycle = this.edit_data.enable_rating_on_cycle
        ? this.edit_data.enable_rating_on_cycle.split(',')
        : []

      enable_rating_on_cycle.map(el => {
        this.model.enable_rating_on_cycle.push(parseInt(el))
      })

      let ignore_scoring_on_cycle = this.edit_data.ignore_scoring_on_cycle
        ? this.edit_data.ignore_scoring_on_cycle.split(',')
        : []

      ignore_scoring_on_cycle.map(el => {
        this.model.ignore_scoring_on_cycle.push(parseInt(el))
      })

      this.edit_data.grade_subjects.map(el => {
        this.model.subject_list.push(el.subject_id)
      })

      this.old_subject_list = this.model.subject_list
      await this.onChangeSubject(this.model.subject_list)

      let is_deleted_subject = this.edit_data.subjects.filter(
        s => s.is_deleted == 1
      )
      is_deleted_subject.map(sb => {
        this.checkedKeys = this.checkedKeys
          .filter(p => !p.includes('H' + sb.term_order))
          .filter(p => !p.includes('H' + sb.term_order + '-' + sb.subject_id))
          .filter(
            p =>
              !p.includes(
                sb.term_order +
                '-' +
                sb.subject_id +
                '-' +
                sb.lea_exp_subject_id
              )
          )
      })

      // this.onChangeLeaExpSubject()
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('grade/RESET_STATE')
      this.$store.commit('grade/SET_EDIT_DATA', {})
    }
    next()
  }
}
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  border-bottom: 1px solid #eee;
  font-size: 12px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}

#subject {
  height: 600px;
  max-height: 600px;
  overflow-x: scroll;
}

#subject-list {
  height: 150px;
  max-height: 300px;
  overflow-x: scroll;
}

#lea-exp-subject-list {
  min-height: 150px;
  max-height: 70vh;
  overflow-x: auto;
}

#subject-list ul li {
  padding-left: 7px;
}
</style>
